import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { baseQueryEtmf } from './baseQueryEtmf';

export const emailActivityAPI = createApi({
  baseQuery: baseQueryEtmf,
  reducerPath: 'emailActivityAPI',
  endpoints: builder => ({
    sendEmail: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, application, module_section_related, parent_entity_related }) => ({
        url: `${formatString(
          endPoints.etmfApis.emailActivity
        )}?site_id=${site_id}&study_id=${study_id}&country_id=${country}&application=${application}&module_section_related=${module_section_related}&parent_entity_related=${parent_entity_related}`,
        method: 'POST',
        body: data
      })
    })
  })
});

export const { useSendEmailMutation } = emailActivityAPI;
